module.exports = __webpack_public_path__ + "static/media/20190808_133836.103ce5b3.png";